import always from 'ramda/es/always'
import pipe from 'ramda/es/pipe'
import includes from 'ramda/es/includes'
import cond from 'ramda/es/cond'
import concat from 'ramda/es/concat'
import equals from 'ramda/es/equals'
import either from 'ramda/es/either'
import flip from 'ramda/es/flip'
import replace from 'ramda/es/replace'
import isNil from 'ramda/es/isNil'
import isEmpty from 'ramda/es/isEmpty'
import tap from 'ramda/es/tap'
import questionTypes from '../QuestionTypes/questionTypes'
import {imageUrls} from 'Shared'
import {quotesRegX, nonBreakingWhiteSpaceRegX, tableNewLinesRegX, newLinesRegX,
        preImagesRegX, imagesRegX, freitextRegX, inputRegX, dropdownWithoutSizeRegX,
        dropdownWithSizeRegX, textBoxRegX, imageTitleRegX, breakRegX, linkRegX, pdfRegX, videosRegX} from '@features/_common/regexe'


//-------------------------------------------------
const log           = x => { console.log(x); return x }
const isNilOrEmpty  = either(isNil, isEmpty)



//######################################################
//#region Replace Handler Helper
//######################################################
//#

    const inputClass                = concat('luecken-text-input-')
    const sizeCheckFor              = x => [equals(x),   ()=>inputClass(x)]
    const smallSizeCheck            = [always(true),     ()=>inputClass('s')]
    const size                      = cond([ sizeCheckFor('xl'), sizeCheckFor('l'), sizeCheckFor('m'), sizeCheckFor('xs'), smallSizeCheck ])
    const delQuotes                 = replace(quotesRegX, '')

    // Counting numbers of each replacement to add unique id
    let taCount = 0         // For text area replacement
    let ibCount = 0         // For input box replacement
    let ddCount = 0         // For dropdown replacement
    let ibddCount = 0       // For dropdown/input box replacement
    const resetCounters = tap( () => { taCount=0; ibCount=0; ddCount=0; ibddCount=0 } )

//#endregion


//######################################################
//#region Handler used in replace functions
//######################################################
//#

const preImagesReplacer = () => (_, text, newLine) => {
    const newLineHtml   = !newLine ? '' : ' <br>'
    return text + newLineHtml
}

const defaultImagesReplacer = () => (_,imageName,w,h) => {
    const widthAttr   = isNilOrEmpty(w) ? '' : `width='${w}'`
    const heightAttr  = isNilOrEmpty(h) ? '' : `height='${h}'`
    const imagePath   = imageUrls.calcPicsPath(imageName)
    return `<object type='image/svg+xml' data='${imagePath}' ${widthAttr} ${heightAttr}></object>`
}


const imgToObjReplacer = () => (_,imageName,w,h,x,l) => {
    const widthAttr     = isNilOrEmpty(w) ? '' : `width:${w}px;`
    const heightAttr    = isNilOrEmpty(h) ? '' : `height:${h}px;`
    const imagePath     = imageUrls.calcPicsPath(imageName)
    const leftStyle     = l ? 'position: absolute; left:' + l + 'px;' : '';
    if (l) {
        return '<div style="position: relative;">' + 
        `<img src='${imagePath}' style='${widthAttr}${heightAttr}${leftStyle}'>`
        + '</div>'
    }

    return `<img src='${imagePath}' style='${widthAttr}${heightAttr}${leftStyle}'>`
}

const textAreasReplacer = () => {
    return (match,w,h) => `<textarea spellcheck="false" autocomplete="off" class='luecken-text-textarea' id="id_${taCount++}" rows='${h}' style='width:${w}px;'></textarea>`
}

const inputBoxesReplacer = () => {
    return (match,widthType,answer) =>
         `<input type="text" spellcheck="false" autocomplete="off" class="luecken-text-input ${size(widthType)}" id="id_${ibddCount++}" data-answer="${delQuotes(answer)}">`
         // `<input type="text" spellcheck="false" autocomplete="off" class="luecken-text-input ${size(widthType)}" id="id_${ibCount++}" data-answer="${delQuotes(answer)}">`
}

let dropDownReplacer = () => {
    return (match, options, widthType, answer) => {
        let toOption        = o => `<option value="${delQuotes( o )}">${delQuotes( o )}</option>`
        let toListItem      = o => `<span><a class="uk-display-block uk-dropdown-close">${delQuotes( o )}</a></span>`
        let htmlOptions     = options.split( ';' ).map( toOption ).join('')
        let htmlListItems   = options.split( ';' ).map( toListItem ).join('')

        const stripNewLines = x => x.replace(/[\n\r]/g, '')
        return  stripNewLines(
                    `<span class="dd-select">
                        <span id="dd_${ibddCount}" class="dropdown-selection ${size( widthType )}">
                            <button class="dd-button uk-button uk-button-default dropdown-button with-cursor uk-flex" type="button">
                                <span class="value uk-text-truncate"></span>
                                <span uk-icon="icon: triangle-down; ratio:1"></span>
                            </button>
                            <span class="dd-selections" uk-toggle uk-dropdown="mode:click; offset:0; animation:uk-animation-slide-top-medium; duration:200; pos: bottom-left">
                                <span class="uk-nav uk-dropdown-nav">${htmlListItems}</span>
                            </span>
                        </span>
                        <select class="luecken-text-select ${size( widthType )}" id="id_${ibddCount++}" data-answer="${delQuotes( answer )}">${htmlOptions}</select>
                     </span>`
                )
    }
}
const dropDownSizelessReplacer  = () => (match,options,answer) => dropDownReplacer()(match, options, 'm', answer)


const textBoxReplacer       = () => { return (match,text) => `<div class='textbox'>\n\n${text}</div>` }
const imageTitleReplacer    = () => { return (match,text) => `<div class='bildunterschrift'>\n\n${text}</div>` }
const linkReplacer       = () => { return (match,fileName,text) => {
    const filePath     = imageUrls.calcFilesPath(fileName)
    return `<a href='${filePath}' target='_blank'>${text}</a>`
} }

const defaultVideosReplacer = () => (_, videoName, w, p) => {
    // Initialize attributes for the video wrapper and iframe
    let heightAttr = '';
    // Container styles make it responsive while respecting max desktop width
    let containerStyle = `style="position:relative;width:100%;max-width:${w}px;"`;
    // Make iframe fill container width for responsiveness
    let iframeStyle = 'style="width:100%;"';

    // Handle fixed height videos: {Video|url|w:600;h:400}
    if (p.startsWith('h:')) {
        const height = p.split(':')[1];
        heightAttr = `height="${height}px"`;
        return `<div ${containerStyle}>
                    <iframe ${heightAttr} ${iframeStyle} src="${videoName}" frameborder="0" 
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>`;
    }
    // Handle aspect ratio videos: {Video|url|w:600;r:16/9}
    else if (p.startsWith('r:')) {
        const ratio = p.split(':')[1];
        return `<div ${containerStyle}>
                    <iframe style="width:100%;aspect-ratio:${ratio};" src="${videoName}" frameborder="0" 
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>`;
    }

    // Default case: only width specified {Video|url|w:600}
    return `<div ${containerStyle}>
                <iframe ${iframeStyle} src="${videoName}" frameborder="0" 
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>`;
};
//#endregion

//######################################################
//#     All specialized parsers
//######################################################
//#
const parseWith                   = (regX, replacer) => text => text.replace(regX, replacer)
const parseNonBreakingWhiteSpace  = replace(nonBreakingWhiteSpaceRegX, '&nbsp;')
const parseTableNewLines          = replace(tableNewLinesRegX, '|\n')
const parseNewLines               = replace(newLinesRegX, '\n <br/>')
const parseBreaks               = parseWith(breakRegX, ' ')
const preParseImages              = parseWith(preImagesRegX, preImagesReplacer())
const parseImages                 = parseWith(imagesRegX, defaultImagesReplacer())
const parseImagesAsImg            = parseWith(imagesRegX, imgToObjReplacer())
const parseTextAreas              = parseWith(freitextRegX, textAreasReplacer())
const parseInputBoxes             = parseWith(inputRegX, inputBoxesReplacer())
const parseDropdowns              = pipe(   parseWith(dropdownWithoutSizeRegX, dropDownSizelessReplacer()),
                                            parseWith(dropdownWithSizeRegX, dropDownReplacer()))

const parseTextBoxes              = parseWith(textBoxRegX, textBoxReplacer())
const parseImageTitles            = parseWith(imageTitleRegX, imageTitleReplacer())
const parseLinks                  = parseWith(linkRegX, linkReplacer())
const parsePDFs                   = parseWith(pdfRegX, linkReplacer())
const parseVideos                 = parseWith(videosRegX, defaultVideosReplacer())



//######################################################
//#     Actual parse pipeline
//######################################################
//#
const pipeWith = imgParser => pipe(
    parseNonBreakingWhiteSpace,
    parseTableNewLines,             // Markdown table newlines for markdown parser: '|<br>' => '|\n' for
    parseNewLines,                  // General new lines
    preParseImages,
    imgParser,
    parseTextAreas,
    resetCounters,
    parseInputBoxes,
    parseDropdowns,
    resetCounters,
    parseTextBoxes,
    parseImageTitles,
    parseLinks,
    parsePDFs,
    parseVideos,
)


//######################################################
//#     Used types of parsers
//######################################################
//#
const parse                 = pipeWith(parseImages)
const parseForSvgAsImg      = pipeWith(parseImagesAsImg)



//######################################################
//#     Helpers to find correct type of parser
//######################################################
//#
const needsSpecialParser    = flip(includes)([questionTypes.clicksvg])
const imgToObjParserCheck   = [needsSpecialParser,    always({transform: parse})]
const defaultImgParserCheck = [always(true),          always({transform: parseForSvgAsImg})]



//######################################################
//#     The only public functions
//######################################################
//#
export const getParserFor   = cond([ imgToObjParserCheck, defaultImgParserCheck ])
export const transform      = parseForSvgAsImg
export const removeBreaks   = parseBreaks

export default {
    transform, getParserFor, removeBreaks
}
